<script setup>
import LIcon from "@/components/shared/LIcon.vue";
import { useUiStore } from "@/stores/ui";
import router from "@/router";

const uiStore = useUiStore();

const props = defineProps({
  data: Object,
});

const action = (type, data) => {
  uiStore.setModalAction(type);
  uiStore.setModalState(true);
  uiStore.setModalData(data);

  if (type == "theme_settings") {
    router.push(`/themes/${props.data.id}`);
  } else if (type == "theme_assignments") {
    router.push(`/themes/assignments/${props.data.id}`);
  }
};
</script>

<template>
  <div class="actions-cell">
    <button @click="action('assign_theme', props.data)" type="button" class="icon-button" title="Assign Theme">
      <LIcon name="plus" />
    </button>
    <button @click="action('theme_assignments', props.data)" type="button" class="icon-button" title="Assignments">
      <LIcon name="list-checks" />
    </button>
    <button @click="action('theme_settings', props.data)" type="button" class="icon-button" title="Settings">
      <LIcon name="palette" />
    </button>
    <button @click="action('edit_theme', props.data)" type="button" class="icon-button" title="Edit">
      <LIcon name="pencil" />
    </button>
    <button @click="action('duplicate_theme', props.data)" type="button" class="icon-button" title="Duplicate">
      <LIcon name="copy" />
    </button>
    <button @click="action('delete_theme', props.data)" type="button" class="icon-button danger" title="Delete" :disabled="props.data.is_default">
      <LIcon name="trash-2" />
    </button>
  </div>
</template>
